import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Spinner from './Spinner';
import { useStoreState } from '@/store';
import {
  ExitSpinnerContainer,
  ExitSpinnerSubText,
  ExitSpinnerText,
  ExitSpinnerTexts,
  SpinnerOverlay,
} from './StyledComponents';
import { getContent } from '@/lib';
// @ts-expect-error untyped-import
import { PurchaseIcon } from '../Spots/Icons/PurchaseIcon';
import { logFPTISpinnerRendered } from './fpti';
import { markSpinnerOnRender } from './utils';
import { logger } from '@/lib/logger';

/*
  TransitionSpinnerContainer is the wrapper for the new spinners:
  - "Almost Done" spinner
  - "Thanks for using PayPal" spinner
  - Empty Spinner
  used when billing page form submits
*/
type TransitionSpinnerContainerProps = {
  titleContent?: string;
  subTitleContent?: string;
  icon?: 'purchase';
  overlayStyleOverrides?: React.CSSProperties;
};
export const TransitionSpinnerContainer = ({
  titleContent,
  subTitleContent,
  icon,
  overlayStyleOverrides,
}: TransitionSpinnerContainerProps): JSX.Element => {
  const merchant = useStoreState(({ api }) => api.cartDetails.merchant);
  const spinnerType = useStoreState(({ ui }) => ui.spinnerType);

  useEffect(() => {
    const prevMarks = window.performance?.getEntriesByName(
      'TransitionSpinnerRender',
    );
    if (prevMarks.length > 0) {
      logger.info('progressive_spinner_unmount_error', { data: prevMarks });
      window.performance?.clearMarks();
    }

    logFPTISpinnerRendered({ spinnerType });
    markSpinnerOnRender({ spinnerType });
    return () => {
      window.performance?.clearMarks();
    };
  }, [spinnerType]);

  return (
    <SpinnerOverlay
      data-testid="exit-loader-spinner"
      style={overlayStyleOverrides}
    >
      <ExitSpinnerContainer>
        <Spinner icon={icon === 'purchase' && <PurchaseIcon />} />
        {/* @ts-expect-error tabIndex worked pre-typescript */}
        <ExitSpinnerTexts tabIndex="0" role="alert">
          {titleContent && (
            <ExitSpinnerText data-testid="spinner-overlay-text">
              {getContent(titleContent)}
            </ExitSpinnerText>
          )}

          {subTitleContent && (
            <ExitSpinnerSubText data-testid="spinner-overlay-subtext">
              {getContent(subTitleContent, {
                merchantName: merchant?.name,
              })}
            </ExitSpinnerSubText>
          )}
        </ExitSpinnerTexts>
      </ExitSpinnerContainer>
    </SpinnerOverlay>
  );
};

TransitionSpinnerContainer.propTypes = {
  icon: PropTypes.elementType,
  overlayStyleOverrides: PropTypes.object,
  subTitleContent: PropTypes.string,
  titleContent: PropTypes.string,
};
